import React from 'react';
import s from './s.module.less';
import { Button, Checkbox, Modal } from 'antd';
import { ExpandOutlined } from '@ant-design/icons';
import GlobalLayerStore from 'store/GlobalLayer';
import { Channel } from 'types/common';
import dayjs from 'utils/dayjs';
import { PATH } from 'constants/path';
import { useNavigate } from 'react-router-dom';

type IProps = {
    onConfirm?: () => void;
};

const PlatformAgreementUrl =
    'https://saas-prod-us.s3.us-east-2.amazonaws.com/prod/agreement/platform-access-and-services-2025102901.html';

const PPAChannelSubscription = (props: IProps) => {
    const navigate = useNavigate();
    const [loading] = React.useState(false);
    const [getGlobalLayer] = GlobalLayerStore.useStore();
    const channel: Channel | undefined = getGlobalLayer('pendingSubscriptionChannel');
    const [checked, setChecked] = React.useState(false);
    const [isFullScreenOpen, setIsFullScreenOpen] = React.useState(false);
    const modalContainerRef = React.useRef<HTMLDivElement>(null);
    const { onConfirm } = props;
    return (
        <div className={s.wrap}>
            <div ref={modalContainerRef} className={s.fullScreenModalContainer} />
            <div className={s.wrapper}>
                <div className={s.logoWrap}>
                    <div className={s.left}>
                        <img src={channel?.logo} />
                    </div>
                    <div className={s.descWrap}>
                        <div className={s.name}>Join {channel?.name}</div>
                        <div className={s.desc}>Per appointment billing</div>
                    </div>
                </div>
                <div className={s.advantage}>
                    <div className={s.titleText}>
                        There are no subscription or monthly fees — you&apos;re
                        only billed when a new patient books with you.
                    </div>
                    <ul className={s.advantageList}>
                        <li className={s.advantageItem}>
                            You&apos;ll be charged $80 lead generation fee 24
                            hours after a new patient books. If the patient
                            cancels within that 24 hours window, you are not
                            charged.
                        </li>
                        <li className={s.advantageItem}>
                            There are no charges for follow-up visits.
                            You&apos;re only billed once per new patient lead.
                        </li>
                        <li className={s.advantageItem}>
                            You can set your own no-show/cancellation policy and
                            decide to charge patients accordingly when those
                            terms are not followed.
                        </li>
                        <li className={s.advantageItem}>
                            Klarity collects the patient&apos;s contact
                            information and insurance details upon booking to
                            help you verify eligibility in advance.
                        </li>
                        <li className={s.advantageItem}>
                            We encourage patients to securely add a credit card
                            on file via the patient portal to support
                            enforcement of your cancellation policy.
                        </li>
                    </ul>
                </div>

                <div className={s.billing}>
                    <div className={s.billingHeader}>
                        <h3 className={s.billingTitle}>{channel?.name}</h3>
                        <div className={s.billingPrice}>
                            $80 per appointment
                        </div>
                    </div>
                    <div className={s.billingDesc}>
                        You only pay when a patient books their initial
                        appointment. Payments are processed automatically via
                        Stripe.
                    </div>
                </div>

                <div className={s.premiumChannel}>
                    <div className={s.title}>
                        Platform agreement confirmation
                    </div>
                    <div className={s.desc}>
                        To ensure transparency and a smooth experience, please
                        review and agree to our Platform Agreement before moving
                        forward.
                    </div>
                    <div className={s.iframeContainer}>
                        <iframe
                            className={s.iframe}
                            title="overview"
                            src={PlatformAgreementUrl}
                        />
                        <Button
                            className={s.expandButton}
                            icon={<ExpandOutlined />}
                            onClick={() => setIsFullScreenOpen(true)}
                            type="text"
                            title="Expand to full screen"
                        />
                    </div>
                </div>

                {/* 全屏查看模态框 */}
                <Modal
                    title="Platform Agreement"
                    open={isFullScreenOpen}
                    onCancel={() => setIsFullScreenOpen(false)}
                    footer={null}
                    width="90vw"
                    style={{ top: 20 }}
                    bodyStyle={{ height: '85vh', padding: 0 }}
                    zIndex={10000}
                    wrapClassName={s.fullScreenModalWrap}
                    getContainer={() => modalContainerRef.current || document.body}
                >
                    <iframe
                        className={s.fullScreenIframe}
                        title="overview-fullscreen"
                        src={PlatformAgreementUrl}
                    />
                </Modal>

                <div className={s.footer}>
                    <div className={s.premiumChannel}>
                        <Checkbox
                            checked={checked}
                            onChange={() => setChecked(!checked)}
                            className="mb-6"
                        >
                            By checking this box, I agree to the terms outlined
                            in the agreement on{' '}
                            {dayjs(new Date().getTime()).format('YYYY-MM-DD')}.
                        </Checkbox>
                    </div>

                    <div className={s.btnWrap}>
                        <Button
                            onClick={async () => {
                                onConfirm?.();
                                navigate(
                                    `${PATH.CHANNEL_PAYMENT}?channelId=${channel?.id}`,
                                );
                                // if (!channel?.subscriptionPriceId) {
                                //     message.error('Plan not set');
                                //     return;
                                // }
                                // setLoading(true);
                                // const result = await getChannelPayLink(channel.id);
                                // if (!result.error) {
                                //     const link = result.data.data;
                                //     if (link) {
                                //         setPendingSubscriptionChannel(channel);
                                //         onConfirm?.();
                                //         window.open(link, '_self');
                                //     } else {
                                //         message.error('Pay link not found');
                                //     }
                                // }

                                // setLoading(false);
                            }}
                            block
                            size="large"
                            type="primary"
                            className={s.btn}
                            loading={loading}
                            disabled={!checked}
                        >
                            Confirm
                        </Button>
                        <div className={s.tips}>
                            By confirming, you authorize the payment using your
                            saved info via Stripe, ensuring a secure
                            transaction.
                        </div>
                        <div className={s.power} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PPAChannelSubscription;
